import { RaffleWinner } from './presenter-widgets.models'

export const MOCK_RAFFLE_WINNERS: RaffleWinner[] = [
  {
    uuid: '1',
    winner_name: 'Alex Johnson',
    prize_name: 'Prize 1',
    ticket_number: '0001',
  },
  {
    uuid: '2',
    winner_name: 'Taylor Smith',
    prize_name: 'Prize 2',
    ticket_number: '0042',
  },
  {
    uuid: '3',
    winner_name: 'Jordan Lee',
    prize_name: 'Prize 3',
    ticket_number: '0107',
  },
  {
    uuid: '4',
    winner_name: 'Morgan Patel',
    prize_name: 'Prize 4',
    ticket_number: '0219',
  },
  {
    uuid: '5',
    winner_name: 'Casey Brown',
    prize_name: 'Prize 5',
    ticket_number: '0345',
  },
  {
    uuid: '6',
    winner_name: 'Sam Williams',
    prize_name: 'Prize 6',
    ticket_number: '0488',
  },
  {
    uuid: '7',
    winner_name: 'Riley Chen',
    prize_name: 'Prize 7',
    ticket_number: '0550',
  },
  {
    uuid: '8',
    winner_name: 'Jamie Garcia',
    prize_name: 'Prize 8',
    ticket_number: '0702',
  },
  {
    uuid: '9',
    winner_name: 'Avery Davis',
    prize_name: 'Prize 9',
    ticket_number: '0813',
  },
  {
    uuid: '10',
    winner_name: 'Quinn Martin',
    prize_name: 'Prize 10',
    ticket_number: '0999',
  },
  {
    uuid: '11',
    winner_name: 'Harper Wilson',
    prize_name: 'Prize 11',
    ticket_number: '1120',
  },
  {
    uuid: '12',
    winner_name: 'Drew Thompson',
    prize_name: 'Prize 12',
    ticket_number: '1255',
  },
  {
    uuid: '13',
    winner_name: 'Sydney Nguyen',
    prize_name: 'Prize 13',
    ticket_number: '1308',
  },
  {
    uuid: '14',
    winner_name: 'Rowan Martinez',
    prize_name: 'Prize 14',
    ticket_number: '1414',
  },
  {
    uuid: '15',
    winner_name: 'Parker Kim',
    prize_name: 'Prize 15',
    ticket_number: '1577',
  },
  {
    uuid: '16',
    winner_name: 'Emerson Clark',
    prize_name: 'Prize 16',
    ticket_number: '1603',
  },
  {
    uuid: '17',
    winner_name: 'Reese Anderson',
    prize_name: 'Prize 17',
    ticket_number: '1719',
  },
  {
    uuid: '18',
    winner_name: 'Logan Wright',
    prize_name: 'Prize 18',
    ticket_number: '1826',
  },
  {
    uuid: '19',
    winner_name: 'Cameron Rivera',
    prize_name: 'Prize 19',
    ticket_number: '1934',
  },
  {
    uuid: '20',
    winner_name: 'Finley Moore',
    prize_name: 'Prize 20',
    ticket_number: '2098',
  },
]
